import type { CategoryPattern } from '../../../hooks/useAdvancedInsights';

interface Props { categories: CategoryPattern[]; }

const trendIcon: Record<string, string> = { up: 'ri-arrow-up-s-line', down: 'ri-arrow-down-s-line', stable: 'ri-subtract-line' };
const trendColor: Record<string, string> = { up: 'text-red-500', down: 'text-emerald-500', stable: 'text-gray-400' };

export const InsightsCategorySection = ({ categories }: Props) => {
  if (!categories.length) return null;
  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 flex items-center justify-center bg-violet-50 rounded-xl">
          <i className="ri-pie-chart-2-line text-violet-500 text-[16px]" />
        </div>
        <div>
          <h2 className="text-[15px] font-700 text-gray-900">Gastos por Categoria</h2>
          <p className="text-[12px] text-gray-400">Comparação com o mês anterior</p>
        </div>
      </div>
      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
        {categories.map((cat, i) => (
          <div key={cat.category} className={`flex items-center gap-3 px-5 py-3.5 ${i < categories.length - 1 ? 'border-b border-gray-50' : ''}`}>
            <div className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: cat.color }} />
            <p className="text-[13px] font-600 text-gray-800 flex-1 truncate">{cat.category}</p>
            <div className="flex items-center gap-3">
              <div className="w-24 hidden sm:block">
                <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                  <div className="h-full rounded-full transition-all" style={{ width: `${cat.percent}%`, backgroundColor: cat.color }} />
                </div>
              </div>
              <p className="text-[12px] text-gray-500 w-8 text-right">{cat.percent}%</p>
              <p className="text-[13px] font-700 text-gray-800 w-24 text-right">{cat.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
              {cat.trendPct > 0 && (
                <div className={`flex items-center gap-0.5 text-[11px] font-600 w-14 justify-end ${trendColor[cat.trend]}`}>
                  <i className={`${trendIcon[cat.trend]} text-[13px]`} />
                  {cat.trendPct}%
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
